import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui';

export default function BillingCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
            <XCircle className="w-8 h-8 text-muted-foreground" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">No changes made</h1>
          <p className="text-muted-foreground">
            The checkout was cancelled. Your plan remains unchanged.
          </p>
        </div>

        <Button asChild variant="outline">
          <Link to="/settings">Back to Settings</Link>
        </Button>
      </div>
    </div>
  );
}
